import './components/login';
import './components/account';
import './components/application';
import './components/basket';
import './components/search';
import './components/event';
import './components/reservations';
import './components/password-reset';

jQuery( function ( $ ) {
	$( '.password' ).password();
	$( '.file-upload' ).file_upload();

	/*	$( '.datepicker' ).flatpickr( {
		dateFormat: 'd-m-Y',
		disableMobile: 'true'
	} );
	$( '.time-select' ).flatpickr( {
		disableMobile: 'true',
		enableTime: true,
		noCalendar: true,
		dateFormat: 'H:i',
		// eslint-disable-next-line camelcase
		time_24hr: true
	} );*/

	$( '.show-more' ).click( function() {
		$( '.show-content' ).slideToggle();
	} );
	$( '.toggle-btn' ).click( function() {
		$( '.container-wrapper' ).toggleClass( 'is-show' );
	} );
	$( '.close-icon' ).click( function() {
		$( '.container-wrapper' ).removeClass( 'is-show' );
	} );
} );
